import { render } from "./LinkInput.vue?vue&type=template&id=8039734e&scoped=true"
import script from "./LinkInput.vue?vue&type=script&lang=js"
export * from "./LinkInput.vue?vue&type=script&lang=js"

import "./LinkInput.vue?vue&type=style&index=0&id=8039734e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8039734e"]])

export default __exports__